const baseEvent = {
  event: 'launchDarklyActiveExperiences',
  eventCategory: 'LaunchDarkly',
  eventAction: 'Active Experiences',
  eventLabel: undefined,
  nonInteractive: true,
  customMetrics: {},
  customVariables: {},
  source: 'FE',
  _clear: true,
}

export default {
  onActiveExperiences: (customVariables: Record<string, string> = {}) => {
    const experiments = useExperiments()
    const launchDarklyExperience
        = Object.entries(experiments)
          .map(
            ([key, value]: [string, any]) =>
              ({ key, value: JSON.stringify(value) })
          )

    return {
      ...baseEvent,
      launchDarklyExperience,
      customVariables
    }
  },

  onActiveEdgeWorkerExperiences: (customVariables: Record<string, string> = {}) => {
    const edgeWorkerExperiments = useEdgeWorkerExperiments().value
    const edgeWorkerExperience
        = Object.entries(edgeWorkerExperiments)
          .map(
            ([key, value]: [string, any]) =>
              ({ key, value: JSON.stringify(value) })
          )

    return {
      ...baseEvent,
      edgeWorkerExperience,
      customVariables
    }
  }
}
